import Api from 'libs/api/index';

class CompanyCategories extends Api {
  constructor() {
    super('admin/company_categories/');
  }
}

export default CompanyCategories;
